<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="conditionForm">
    <!-- Question Code -->
    <mat-form-field class="w-100">
      <mat-label>Question</mat-label>
      <mat-select [formControlName]="Controls.QuestionCode" required>
        <mat-option *ngFor="let question of questionCodes" [value]="question.key"
                    matTooltip="{{question.value}}" matTooltipPosition="above">
          {{question.value}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <!-- Condition/Diagnosis Group -->
    <mat-form-field *ngIf="!conditionFreeTextActive" class="w-100">
      <mat-label>Condition</mat-label>
      <mat-select [formControlName]="Controls.ConditionCode" required>
        <mat-option *ngFor="let diagnosisGroup of data?.diagnosisGroups" [value]="diagnosisGroup.code">
          {{diagnosisGroup.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Condition/Diagnosis Group free text-->
    <mat-form-field *ngIf="conditionFreeTextActive" class="w-100">
      <mat-label>Condition</mat-label>
      <input [formControlName]="Controls.ConditionCode" matInput type="text">
    </mat-form-field>

    <div *ngIf="conditionForm.get(Controls.QuestionCode)?.value">
      <mat-checkbox  [formControlName]="Controls.ConditionFreeTextActive" (change)="onConditionFreeTextChange($event)">
        Cannot find the condition in the list above?
      </mat-checkbox>
    </div>
    
    <!-- Provider Autocomplete -->
    <mat-form-field class="w-100">
      <mat-label>Provider</mat-label>
      <input type="text" matInput
             placeholder="Search by name or practice number"
             [formControlName]="Controls.Provider"
             [matAutocomplete]="providerAuto"
             (input)="onProviderSearch($event.target.value)">
      <mat-autocomplete #providerAuto="matAutocomplete" [displayWith]="getProviderDisplayString.bind(this)">
          <mat-option *ngFor="let provider of providers" [value]="provider.providerId">
            <span>{{getProviderDisplayString(provider.providerId)}}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    
    <!-- Medication Autocomplete -->
    <mat-form-field class="w-100">
      <mat-label>Medication</mat-label>
      <input type="text" matInput
             placeholder="Search by name or code"
             [formControlName]="Controls.Medication"
             [matAutocomplete]="medicationAuto"
             (input)="onMedicationSearch($event.target.value)">
      <mat-autocomplete #medicationAuto="matAutocomplete" [displayWith]="getMedicationDisplayString.bind(this)">
        <mat-option *ngFor="let medication of medications" [value]="medication.nationalDrugId">
          <span>{{getMedicationDisplayString(medication.nationalDrugId)}}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    
    <!-- Treatment Dates -->
    <mat-form-field class="w-100">
      <mat-label>First Treatment Date</mat-label>
      <input matInput [matDatepicker]="firstTreatmentPicker"
             [formControlName]="Controls.FirstTreatmentDate" required
             [max]="conditionForm.get(Controls.LastTreatmentDate).value">
      <mat-datepicker-toggle matIconSuffix [for]="firstTreatmentPicker">
      </mat-datepicker-toggle>
      <mat-datepicker #firstTreatmentPicker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field class="w-100">
      <mat-label>Last Treatment Date</mat-label>
      <input matInput [matDatepicker]="lastTreatmentPicker"
             [formControlName]="Controls.LastTreatmentDate" required
             [min]="conditionForm.get(Controls.FirstTreatmentDate).value">
      <mat-datepicker-toggle matIconSuffix [for]="lastTreatmentPicker">
      </mat-datepicker-toggle>
      <mat-datepicker #lastTreatmentPicker></mat-datepicker>
    </mat-form-field>
    
    <!-- Is Current Toggle -->
    <app-element-slide-toggle
      [label]="'Is Current'"
      [formControlName]="Controls.IsCurrent">
    </app-element-slide-toggle>
  </form>
</div>

<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
  <button class="dialog-button" mat-raised-button color="primary"
          [disabled]="!conditionForm.valid"
          (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>